/**=========================================================
 * Module: addresses.js
 * Addresses Controller
 =========================================================*/

App.controller("AddressesController", ["$rootScope", "$scope", "$state", "$translate", "$window", "$localStorage", "$timeout", "toggleStateService", "Restangular", "DataService",
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D) 
  {
    "use strict";

    $scope.type = "account";
    $scope.filter = $state.params.filter;
    if($state.params.filter.indexOf("=")>0){
      $scope.f = JSON.parse('{"' + decodeURI($state.params.filter.replace("%09"," ")).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
    } else {
      $scope.f = {};
    }

    $scope.page = {
      title: "labels.USERS",
      subTitle: ""
    };

    $scope.form = {
      model: {
        createdAfter: null
      }
    }

    $scope.filterFields = [
      {
        type: 'date',
        name: 'createdAfter',
        minDate: new Date(2015, 0, 0, 0, 0, 0, 0),
        labelColumn: 4,
        inputColumn: 8,
        onchange: function(){
          list();
        }

      }
    ]

    var list = function(){
      var response = $scope.data;
      $scope.emails = "";
        $scope.counter = 0;
        for (var i = 0; i < response.length; i++) {
          var u = response[i];
          if(u.groupType=='ADMIN' || !u.enabled || u.role=='LIMITED') continue;
          if($scope.form.model.createdAfter) {
            var d = moment($scope.form.model.createdAfter);
            if(u.createdOn < d.toDate().getTime()) continue;
          }
          if($scope.emails) $scope.emails += ', ';
          $scope.emails += u.name + ' <' + u.email + '>';
          $scope.counter++;
        }
    }

    D.query($scope.type, $scope.filter + '&_export=true').then(
      function(response) {
        $scope.data = response;
        list();
      },
      function(error) {
        $scope.error = error;
      }
    ).catch(console.error);
  }
]);
